export default class SampleCSVFilesJwtServices {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.sampleCSVFileEndpoint, {
      params
    })
  }

  create(payload) {
    return this.axiosIns.post(`${this.jwtConfig.main.sampleCSVFileEndpoint}`, payload)
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.sampleCSVFileEndpoint}/${id}`, {})
  }

  update(id, formData) {
    return this.axiosIns.put(`${this.jwtConfig.main.sampleCSVFileEndpoint}/${id}`, formData);
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.sampleCSVFileEndpoint}/${id}`, {})
  }

  download(reference) {
    return this.axiosIns.get(`${this.jwtConfig.main.sampleCSVFileEndpoint}/${reference}/download`)
  }
}
